import CaptchaProvider from '../captcha-data/gmst-captcha-provider';
import { StateManager } from '../gmwc-core/gmwc-core';
import React, {useImperativeHandle, useRef} from "react";
import {useEffect, useState} from "react";

const GmstCaptcha = React.forwardRef(({ autoFocus = 'autofocus', placeholder = '', session, cookie, state}, ref) => {
  const [captchaId, setCaptchaId] = useState(null);
  const [userInput, setUserInput] = useState('');
  const [captchaImage, setCaptchaImage] = useState(null);
  const [cID, setCID] = useState(null);
  const [refreshButtonDisabled, setRefreshButtonDisabled] = useState(false);

  const labelRef = useRef(null);
  const submitButtonRef = useRef(null);
  const refreshButtonRef = useRef(null);
  const captchaInputRef = useRef(null);

  // This allows the parent component to access the functions defined in useImperativeHandle
  useImperativeHandle(ref, () => ({
    labelRef,
    submitButtonRef,
    refreshButtonRef,
    captchaInputRef
  }));

  useEffect(() => {
    getCaptchaID();
  }, []);

  const getStoredValue = (key) => {
    if (session) {
      return sessionStorage.getItem(key);
    }
    else if (cookie) {
      let v = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
      return v ? v[2] : null;
    }
    else if (state) {
      return StateManager.getParam(key);
    }
  }

  const storeData = (key, value) => {
    if (session) {
      sessionStorage.setItem(key, value);
    }
    if (cookie) {
      document.cookie = `${key}=${value}`;
    }
    if (state) {
      StateManager.setParam(key, value);
    }
  }


  const getCaptchaID = () => {
    let currentcID = getStoredValue('cID') === null || getStoredValue('cID') === 'undefined' ? 0 : getStoredValue('cID');
    CaptchaProvider.captchaID(currentcID)
      .then(cID => {
        storeData('cID', cID);
        getCaptcha();
      });
  }

  const getCaptcha = () => {
    let cID = getStoredValue('cID');
    setRefreshButtonDisabled(true);

    CaptchaProvider.captchaImage(cID)
      .then(image => {
        setCaptchaImage(image);
        setRefreshButtonDisabled(false);
      });
  }

  return (
    <div>
      <div className="gmst-captcha-image-container">
        {captchaImage && <img src={captchaImage.src} alt={captchaImage.alt} className={captchaImage.className} id={captchaImage.id} />}
      </div>
      <div className="input-container">
        <label ref={labelRef} htmlFor="captchaInput">Please enter the text displayed</label>
        <input type="text" ref={captchaInputRef} id="captchaInput" maxLength="6" name="captcha" placeholder={placeholder} autoFocus={autoFocus} onChange={(e) => setUserInput(e.target.value)} />
      </div>
      <div className="buttons-container">
        <button ref={submitButtonRef} className="gmst-captcha-submit" type="button" value="Submit" >Submit</button>
        <button ref={refreshButtonRef} className="gmst-captcha-refresh" type="button" value="Refresh" disabled={refreshButtonDisabled} onClick={getCaptcha}>Refresh</button>
      </div>
    </div>
  );
});

export default GmstCaptcha;

// export const GMSTCaptcha = customElements.define("gmst-captcha", GmstCaptcha);